import React, { Component } from "react";

import { getRequest } from "../../api/ApiService";
import PeerEvaluationModal from "../../components/peer-evaluation/peer-evaluation-modal";
import PeerEvaluationFeedback from "../../components/peer-evaluation/peer-evaluation-feedback";
import styled from "styled-components";

const ViewEvaluationButtonContainer = styled.div`
  margin-bottom: 12.5px;

  .peerModal {
    height: 737px;
  }
`;

const ViewEvaluationButton = styled.div`
  display: inline-block;
  border: 1.5px solid #2A4169;
  color: #2A4169;
  padding: 5px 10px;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 23px;
  border-radius: 8px;
  margin-right: 10px;
  background: #fff;
  cursor: pointer;
`;

class StudentStatsViewEvaluation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questionsOrder: [],
      isIntroScreen: true,
      isFinalScreen: false,
      isTransitionScreen: false,
      currentPage: 0,
      questionsCount: 0,
      self_assessment_count: 0,
      peer_rating_count: 0,
      final_reflection_count: 0,
      show: false,
      progressBar: [],
      answers: [],
      submitPages: {},
    };
  }

  async componentDidMount() {
    await this.getAnswersList();

    let progressBar = [
      {
        id: 1,
        title: "1. Self Assessment",
        progress: 0
      },
      {
        id: 2,
        title: "2. Peer Rating",
        progress: 0,
        isDisabled: true
      },
      {
        id: 3,
        title: "3. Final Reflection",
        progress: 0,
        isDisabled: true
      }
    ];

    this.setState({
      progressBar
    });
  }

  async getAnswersList() {
    const { survey, selected } = this.props;
    const { body: answersBody } = await getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/answers-list/?survey=${survey.id}&receiver=${selected.student.user.id}`
    );

    let formsAnswersList = answersBody.results;
    const nextPageAvailable = answersBody.next;
    if (nextPageAvailable) {
      const newFormsAnswersList = await this.fetchFormsAnswersList(nextPageAvailable);
      formsAnswersList.push(...newFormsAnswersList);
    }

    this.setState({
      answers: formsAnswersList
    }, () => {
      this.questionsOrder();
    });
  }

  fetchFormsAnswersList = async (nextPage) => {
    let nextPageAvailable = true;
    let formsAnswersList = [];
    let nextPageUrl = nextPage;

    while (nextPageAvailable) {
      nextPageAvailable = false;
      await getRequest(
        nextPageUrl
      )
        // eslint-disable-next-line no-loop-func
        .then(res => {
          nextPageUrl = res.body.next;
          nextPageAvailable = nextPageUrl;
          formsAnswersList.push(...res.body.results);
        })
        .catch(err => { });
    }

    return formsAnswersList;
  }

  questionsOrder = () => {
    const { survey, reports, students, selected } = this.props;
    const { answers } = this.state;
    const user_score_question = reports[survey.stage] ? reports[survey.stage].user_score_question : [];
    const freeform_answers = reports[survey.stage] ? reports[survey.stage].freeform_answers : [];

    const survey_self_assessment_questions = survey.questions.filter(question =>
      question.category === "self_assessment"
      && question.answer_type === "freeform"
      && (
        question.text.includes('What was your biggest takeaway')
        || question.text.includes('What\'s working well')
        || question.text.includes('What could work better')
        || question.text.includes('If you had a chance to do it all over again')
      )
    );
    const self_assessment_questions = survey_self_assessment_questions.map((item, index) => {
      const currentAnswer = freeform_answers.find(freeform_answer => freeform_answer.survey_question === item.id)
      const currentAnswerText = currentAnswer ? currentAnswer.text : ''
      return (
        {
          id: index + 1,
          text: item.text,
          category: 'self_assessment',
          answer_type: 'freeform',
          value: currentAnswerText
        })
    });

    const peer_rating_questions = user_score_question.map((item, index) => (
      {
        id: index + 1,
        text: item.question,
        category: 'likert',
        answer_type: 'rating',
        value: Math.round(item.median)
      }
    ));

    const currentUser = selected.student.user;
    const survey_final_reflection_questions = survey.questions.filter(question =>
      question.text.includes('I Like:')
      || question.text.includes('I Wish:')
    );

    const final_reflection_questions = survey_final_reflection_questions.map((item, index) => {
      const questionAnswers = answers.filter(
        answer => answer.question_text === item.text
      )
        .map(answer => {
          const student = students.find(student => student.user.email === answer.giver_email);
          const initials = `${student.user.first_name.charAt(0)}.${student.user.last_name.charAt(0)}`;
          return ({
            name: initials,
            text: answer.answer_text
          })
        });
      return (
        {
          id: index + 1,
          text: this.formatFinalReflectionTitle(item.text, `${currentUser.first_name} ${currentUser.last_name}`),
          category: 'like_wish_results',
          answer_type: 'freeform',
          items: questionAnswers
        })
    });

    let questionsOrder = [
      { answer_type: "self_assessment_results_intro" },
      ...self_assessment_questions,
      { answer_type: "peer_rating_feedback_intro" },
      ...peer_rating_questions,
      { answer_type: "final_reflections_results_intro" },
      ...final_reflection_questions
    ];

    questionsOrder.push({ answer_type: "final_peer_rating_page" });

    this.setState(() => ({
      questionsOrder,
      questionsCount: questionsOrder.length - 1,
      self_assessment_count: self_assessment_questions.length,
      peer_rating_count: peer_rating_questions.length,
      final_reflection_count: final_reflection_questions.length,
    }));
  };

  pasteTeamateName = (text, name) => {
    let result = text;
    const replacements = ['this teammate', '<insert teammate name>', '<insert name>', '<Insert User FirstName>'];
    for (const replacement of replacements) {
      result = result.replace(replacement, `<span>${name}</span>`);
    }

    return result;
  }

  formatFinalReflectionTitle = (text, name) => {
    const likeStyle = 'color: #55B4BC;';
    const wishStyle = 'color: #ECA427;';

    let changedText = text;
    if (changedText.includes('I Like:')) {
      changedText = `Here’s what your students like about working with <span style="${likeStyle}">${name}</span>.`
    }
    if (changedText.includes('I Wish:')) {
      changedText = `Here’s what your students wish <span style="${wishStyle}">${name}</span> could do more of.`
    }

    return changedText;
  }

  isIntroScreen = nextPage => {
    const { questionsOrder } = this.state;
    const type = questionsOrder[nextPage].answer_type;

    return (
      type === "peer_rating_feedback_intro"
    );
  };

  isFinalScreen = nextPage => {
    const { questionsOrder } = this.state;
    const type = questionsOrder[nextPage].answer_type;

    return type === "final_peer_rating_page";
  }

  isTransitionScreen = nextPage => {
    const { questionsOrder } = this.state;
    const type = questionsOrder[nextPage].answer_type;

    return type === "transition_page";
  }

  handleShowModal = () => {
    const { onEvaluationShowToggle } = this.props;
    this.setState(
      () => ({ show: true }),
      () => onEvaluationShowToggle()
    );
  };

  handleHideModal = () => {
    const { onEvaluationShowToggle } = this.props;
    this.setState(prevState => ({
      show: false,
      currentPage: 0,
      isIntroScreen: true,
      isFinalScreen: false,
      isTransitionScreen: false,
      submitPages: {},
      progressBar: prevState.progressBar.map(item => ({ ...item, progress: 0 }))
    }), () => onEvaluationShowToggle());
  };

  goToNextPage = () => {
    const {
      currentPage,
      questionsCount,
      self_assessment_count,
      peer_rating_count,
      final_reflection_count
    } = this.state;

    let nextPage = currentPage + 1;
    if (nextPage > questionsCount) {
      nextPage = questionsCount;
    }

    const isIntroScreen = this.isIntroScreen(nextPage);
    const isFinalScreen = this.isFinalScreen(nextPage);
    const isTransitionScreen = this.isTransitionScreen(nextPage);

    this.setState(prevState => ({
      currentPage: nextPage,
      isIntroScreen,
      isFinalScreen,
      isTransitionScreen,
      progressBar: prevState.progressBar.map(item =>
        item.id === 1
          ? {
            ...item,
            progress: Math.min((nextPage / self_assessment_count) * 100, 100)
          }
          :
          item.id === 2
            ? {
              ...item,
              progress: Math.min((Math.max(nextPage - self_assessment_count - 1, 0) / peer_rating_count) * 100, 100),
              isDisabled: nextPage <= self_assessment_count
            }
            :
            item.id === 3
              ? {
                ...item,
                progress: Math.min((Math.max(nextPage - self_assessment_count - peer_rating_count - 2, 0) / final_reflection_count) * 100, 100),
                isDisabled: nextPage <= self_assessment_count + peer_rating_count + 1
              }
              : item
      )
    }));
  };

  goToPrevPage = () => {
    const {
      currentPage,
      self_assessment_count,
      peer_rating_count,
      final_reflection_count
    } = this.state;

    let prevPage = currentPage - 1;
    if (prevPage < 1) {
      prevPage = 1;
    }

    const isIntroScreen = this.isIntroScreen(prevPage);
    const isFinalScreen = this.isFinalScreen(prevPage);
    const isTransitionScreen = this.isTransitionScreen(prevPage);

    this.setState(prevState => ({
      currentPage: prevPage,
      isIntroScreen,
      isFinalScreen,
      isTransitionScreen,
      progressBar: prevState.progressBar.map(item =>
        item.id === 1
          ? {
            ...item,
            progress: Math.min((prevPage / self_assessment_count) * 100, 100)
          }
          :
          item.id === 2
            ? {
              ...item,
              progress: Math.min((Math.max(prevPage - self_assessment_count - 1, 0) / peer_rating_count) * 100, 100),
              isDisabled: prevPage <= self_assessment_count
            }
            :
            item.id === 3
              ? {
                ...item,
                progress: Math.min((Math.max(prevPage - self_assessment_count - peer_rating_count - 2, 0) / final_reflection_count) * 100, 100),
                isDisabled: prevPage <= self_assessment_count + peer_rating_count + 1
              }
              : item
      )
    }));
  };

  render() {
    const {
      survey
    } = this.props;

    const {
      show,
      questionsOrder,
      isIntroScreen,
      isFinalScreen,
      isTransitionScreen,
      currentPage,
      progressBar,
      self_assessment_count,
      peer_rating_count,
      teamList,
      questionsCount,
      submitPages,
    } = this.state;

    const currentQuestion = questionsOrder[currentPage];
    const hasAnswer = true;

    return (
      <ViewEvaluationButtonContainer>
        <ViewEvaluationButton onClick={this.handleShowModal}>
          View Evaluation
        </ViewEvaluationButton>
        <PeerEvaluationModal
          surveyId={survey ? survey.id : null}
          show={show}
          onHide={this.handleHideModal}
          onSubmit={this.goToNextPage}
          progressBar={progressBar}
          submitButtonText={submitPages[currentPage] ? "Submit" : isIntroScreen ? "Start" : "Save & Continue"}
          currentPage={currentPage ? Number(currentPage) : 0}
          countOfPages={questionsCount ? Number(questionsCount) : 0}
          goNext={this.goToNextPage}
          goPrev={this.goToPrevPage}
          canSubmit={hasAnswer}
          isFinalScreen={isFinalScreen}
          isTransitionScreen={isTransitionScreen}
          readonlyMode={true}
          linearExtraId="_peer-review"
        >
          {!!currentQuestion && (
            <PeerEvaluationFeedback
              question={currentQuestion}
              answers={[]}
              self_assessment_count={self_assessment_count}
              peer_rating_count={peer_rating_count}
              teamList={teamList}
              feedbacks={{}}
              readonlyMode={true}
            />
          )}
        </PeerEvaluationModal>
      </ViewEvaluationButtonContainer>
    );
  }
}

export default StudentStatsViewEvaluation;



// WEBPACK FOOTER //
// ./src/instructor/components/student-stats-view-evaluation.js